/* Suppliers feature: list page, create form, and the supplier profile
 * (overview, profile, contacts, addresses, bank accounts, documents, notes,
 * activity, catalog/price list, purchases, spend). Shared vocabulary lives in
 * common.js / shell.js — do not duplicate it here. */
const suppliers = {
  // --- Suppliers list page ---------------------------------------------------
  'Manage your vendors, contacts and payment terms.': 'Kelola vendor, kontak, dan syarat pembayaran Anda.',
  'New supplier': 'Pemasok baru',
  'Search by name, code or email…': 'Cari berdasarkan nama, kode, atau email…',
  'Failed to load suppliers.': 'Gagal memuat pemasok.',
  "Couldn't load suppliers": 'Tidak dapat memuat pemasok',
  'No matching suppliers': 'Tidak ada pemasok yang cocok',
  'No suppliers yet': 'Belum ada pemasok',
  'Try adjusting your search or filters.': 'Coba sesuaikan pencarian atau filter Anda.',
  'Add your first supplier to start purchasing.': 'Tambahkan pemasok pertama Anda untuk mulai membeli.',
  'Add a vendor to your organization. You can complete the full profile next.': 'Tambahkan vendor ke organisasi Anda. Anda dapat melengkapi profil lengkapnya setelah ini.',
  'Supplier created': 'Pemasok dibuat',
  'Could not create supplier': 'Tidak dapat membuat pemasok',
  'Supplier deleted': 'Pemasok dihapus',
  'Could not delete supplier': 'Tidak dapat menghapus pemasok',
  'Delete supplier': 'Hapus pemasok',
  'Open supplier': 'Buka pemasok',
  'Delete "{name}"? This action cannot be undone.': 'Hapus "{name}"? Tindakan ini tidak dapat dibatalkan.',
  'Terms': 'Syarat',
  '{days}d': '{days} hr',

  // --- Statuses & filters ----------------------------------------------------
  'On hold': 'Ditahan',
  'Archived': 'Diarsipkan',
  'Preferred': 'Utama',
  'Preferred only': 'Hanya yang diutamakan',
  'Not preferred': 'Tidak diutamakan',
  'Payment terms (days)': 'Syarat pembayaran (hari)',
  'Lead time (days)': 'Waktu tunggu (hari)',

  // --- Supplier form ----------------------------------------------------------
  'Name is required.': 'Nama wajib diisi.',
  'Enter a valid email.': 'Masukkan email yang valid.',
  'Select a currency.': 'Pilih mata uang.',
  'Must be between 0 and 365.': 'Harus antara 0 dan 365.',
  'Code': 'Kode',
  'Tax ID': 'ID pajak (NPWP)',
  'Create supplier': 'Buat pemasok',

  // --- Profile page shell ------------------------------------------------------
  'Failed to load supplier.': 'Gagal memuat pemasok.',
  "Couldn't load supplier": 'Tidak dapat memuat pemasok',
  'This supplier may have been removed.': 'Pemasok ini mungkin telah dihapus.',
  'Back to suppliers': 'Kembali ke pemasok',
  'Status set to {status}': 'Status diubah menjadi {status}',
  'Could not change status': 'Tidak dapat mengubah status',
  'Status: {status}': 'Status: {status}',
  'Edit profile': 'Ubah profil',
  'Profile completeness': 'Kelengkapan profil',
  '{count} expiring': '{count} segera kedaluwarsa',
  'Activity events': 'Peristiwa aktivitas',
  'Days as supplier': 'Hari sebagai pemasok',
  'Supplier sections': 'Bagian pemasok',
  'No access': 'Tidak ada akses',
  "You don't have permission to view purchase orders.": 'Anda tidak memiliki izin untuk melihat pesanan pembelian.',
  'Coming soon': 'Segera hadir',
  'Delete "{name}"? This also removes its contacts, documents and notes. This cannot be undone.': 'Hapus "{name}"? Ini juga menghapus kontak, dokumen, dan catatannya. Tindakan ini tidak dapat dibatalkan.',

  // --- Tabs --------------------------------------------------------------------
  'Overview': 'Ikhtisar',
  'Profile': 'Profil',
  'Contacts': 'Kontak',
  'Contacts ({count})': 'Kontak ({count})',
  'Addresses': 'Alamat',
  'Addresses ({count})': 'Alamat ({count})',
  'Bank accounts': 'Rekening bank',
  'Bank accounts ({count})': 'Rekening bank ({count})',
  'Documents': 'Dokumen',
  'Documents ({count})': 'Dokumen ({count})',
  'Notes ({count})': 'Catatan ({count})',
  'Purchases': 'Pembelian',
  'Spend': 'Pengeluaran',

  // --- Overview tab --------------------------------------------------------------
  'Profile is {percent}% complete': 'Profil {percent}% lengkap',
  'Complete profile': 'Lengkapi profil',
  'About': 'Tentang',
  'Company': 'Perusahaan',
  'Commercial terms': 'Ketentuan komersial',
  'Compliance & links': 'Kepatuhan & tautan',
  'Primary contact & address': 'Kontak & alamat utama',
  'Legal name': 'Nama resmi',
  'Trade name': 'Nama dagang',
  'Website': 'Situs web',
  'Rating': 'Penilaian',
  'Payment terms': 'Syarat pembayaran',
  'Lead time': 'Waktu tunggu',
  '{count} days': '{count} hari',
  'Incoterms': 'Incoterms',
  'Payment method': 'Metode pembayaran',
  'Min. order': 'Pesanan min.',
  'Registration no.': 'No. registrasi',
  'No contact yet.': 'Belum ada kontak.',
  'No address yet.': 'Belum ada alamat.',

  // --- Profile (edit) tab ----------------------------------------------------------
  'Identity': 'Identitas',
  'Display name': 'Nama tampilan',
  'Supplier code': 'Kode pemasok',
  'Trade name (DBA)': 'Nama dagang (DBA)',
  'Food & Beverage': 'Makanan & Minuman',
  'Not rated': 'Belum dinilai',
  '1 - Poor': '1 - Buruk',
  '2 - Fair': '2 - Cukup',
  '3 - Good': '3 - Baik',
  '4 - Very good': '4 - Sangat baik',
  '5 - Excellent': '5 - Istimewa',
  'Preferred supplier': 'Pemasok diutamakan',
  'Highlight this supplier in selection lists.': 'Tonjolkan pemasok ini di daftar pemilihan.',
  'Tags': 'Tag',
  'Comma-separated, e.g. organic, local, certified': 'Dipisahkan koma, mis. organik, lokal, bersertifikat',
  'About / description': 'Tentang / deskripsi',
  'Contact channels': 'Saluran kontak',
  'Options are configured in Settings → Commercial standards.': 'Opsi diatur di Pengaturan → Standar komersial.',
  'No term': 'Tanpa syarat',
  '{name} · {days} days': '{name} · {days} hari',
  'No method': 'Tanpa metode',
  'No terms': 'Tanpa ketentuan',
  '{value} (custom)': '{value} (kustom)',
  'Min. order value': 'Nilai pesanan min.',
  'Compliance & ecosystem links': 'Kepatuhan & tautan ekosistem',
  'Registration number': 'Nomor registrasi',
  'Prostay Accounting supplier ID': 'ID pemasok Prostay Accounting',
  'TableView supplier ID': 'ID pemasok TableView',
  'Profile saved': 'Profil disimpan',
  'Could not save profile': 'Tidak dapat menyimpan profil',

  // --- Contacts tab ------------------------------------------------------------------
  'Add contact': 'Tambah kontak',
  'No contacts yet': 'Belum ada kontak',
  'Add the people you deal with at this supplier.': 'Tambahkan orang-orang yang Anda hubungi di pemasok ini.',
  'Primary': 'Utama',
  'Primary contact': 'Kontak utama',
  'Title': 'Judul',
  'Account Manager': 'Manajer Akun',
  'Role': 'Peran',
  'Sales, AP…': 'Penjualan, Utang usaha…',
  'Save contact': 'Simpan kontak',
  'Contact updated': 'Kontak diperbarui',
  'Contact added': 'Kontak ditambahkan',
  'Could not save contact': 'Tidak dapat menyimpan kontak',
  'Contact removed': 'Kontak dihapus',
  'Could not remove contact': 'Tidak dapat menghapus kontak',
  'Edit contact': 'Ubah kontak',
  'Remove contact': 'Hapus kontak',
  'Remove {name}?': 'Hapus {name}?',

  // --- Addresses tab --------------------------------------------------------------------
  'Add address': 'Tambah alamat',
  'No addresses yet': 'Belum ada alamat',
  'Add billing, shipping and remittance addresses.': 'Tambahkan alamat penagihan, pengiriman, dan remitansi.',
  'Address type': 'Tipe alamat',
  'Headquarters': 'Kantor pusat',
  'Billing': 'Penagihan',
  'Shipping': 'Pengiriman',
  'Remittance': 'Remitansi',
  'Warehouse': 'Gudang',
  'Other': 'Lainnya',
  'Label': 'Label',
  'Main warehouse': 'Gudang utama',
  'Address line 1': 'Baris alamat 1',
  'Address line 2': 'Baris alamat 2',
  'City': 'Kota',
  'State / Province': 'Negara bagian / Provinsi',
  'Postal code': 'Kode pos',
  'Country': 'Negara',
  'Primary address': 'Alamat utama',
  'Save address': 'Simpan alamat',
  'Address updated': 'Alamat diperbarui',
  'Address added': 'Alamat ditambahkan',
  'Could not save address': 'Tidak dapat menyimpan alamat',
  'Address removed': 'Alamat dihapus',
  'Could not remove address': 'Tidak dapat menghapus alamat',
  'Edit address': 'Ubah alamat',
  'Remove address': 'Hapus alamat',
  'Remove this {type} address?': 'Hapus alamat {type} ini?',

  // --- Bank accounts tab --------------------------------------------------------------------
  'Add bank account': 'Tambah rekening bank',
  'No bank accounts yet': 'Belum ada rekening bank',
  "Add the supplier's bank details so payments can be remitted to the right account.": 'Tambahkan detail bank pemasok agar pembayaran dikirim ke rekening yang benar.',
  'Bank name': 'Nama bank',
  'Bank name is required.': 'Nama bank wajib diisi.',
  'Branch': 'Cabang',
  'Account name': 'Nama rekening',
  'Account name is required.': 'Nama rekening wajib diisi.',
  'Account number': 'Nomor rekening',
  'Account number is required.': 'Nomor rekening wajib diisi.',
  'Account currency': 'Mata uang rekening',
  'Main IDR account': 'Rekening IDR utama',
  'e.g. use for invoices over IDR 50M': 'mis. gunakan untuk faktur di atas IDR 50 jt',
  'Primary account for payments': 'Rekening utama untuk pembayaran',
  'Save bank account': 'Simpan rekening bank',
  'Bank account updated': 'Rekening bank diperbarui',
  'Bank account added': 'Rekening bank ditambahkan',
  'Could not save bank account': 'Tidak dapat menyimpan rekening bank',
  'Bank account removed': 'Rekening bank dihapus',
  'Could not remove bank account': 'Tidak dapat menghapus rekening bank',
  'Edit bank account': 'Ubah rekening bank',
  'Remove bank account': 'Hapus rekening bank',
  'Remove the account at {bank} ending in {digits}?': 'Hapus rekening di {bank} yang berakhiran {digits}?',

  // --- Documents tab --------------------------------------------------------------------
  'Upload document': 'Unggah dokumen',
  'No documents yet': 'Belum ada dokumen',
  'Upload contracts, insurance certificates, tax forms and price lists using the button above.': 'Unggah kontrak, sertifikat asuransi, formulir pajak, dan daftar harga dengan tombol di atas.',
  'Could not load documents': 'Tidak dapat memuat dokumen',
  'Choose a file to upload': 'Pilih berkas untuk diunggah',
  'Document uploaded': 'Dokumen diunggah',
  'Upload failed': 'Unggahan gagal',
  'Could not open document': 'Tidak dapat membuka dokumen',
  'Document removed': 'Dokumen dihapus',
  'Could not remove document': 'Tidak dapat menghapus dokumen',
  'Delete document': 'Hapus dokumen',
  'Delete "{name}"? This permanently removes the file.': 'Hapus "{name}"? Ini menghapus berkas secara permanen.',
  'Uploaded {date}': 'Diunggah {date}',
  'Expired {date}': 'Kedaluwarsa sejak {date}',
  'Expires in {days}d': 'Kedaluwarsa dalam {days} hr',
  'Expires {date}': 'Kedaluwarsa {date}',
  'PDF, image or Office file up to {n} MB': 'PDF, gambar, atau berkas Office hingga {n} MB',
  'Document type': 'Tipe dokumen',
  'Expiry date (optional)': 'Tanggal kedaluwarsa (opsional)',
  'Description (optional)': 'Deskripsi (opsional)',
  'Contract': 'Kontrak',
  'Insurance': 'Asuransi',
  'Tax form': 'Formulir pajak',
  'Certification': 'Sertifikasi',
  'License': 'Lisensi',
  'Price list': 'Daftar harga',

  // --- Notes tab --------------------------------------------------------------------
  'Add a note about this supplier…': 'Tambahkan catatan tentang pemasok ini…',
  'Pin to top': 'Sematkan di atas',
  'Add note': 'Tambah catatan',
  'No notes yet': 'Belum ada catatan',
  'Capture call summaries, issues and reminders here.': 'Catat ringkasan panggilan, masalah, dan pengingat di sini.',
  'User': 'Pengguna',
  'Pinned': 'Disematkan',
  'Pin': 'Sematkan',
  'Unpin': 'Lepas sematan',
  'Edit note': 'Ubah catatan',
  'Delete note': 'Hapus catatan',
  'Delete this note? This cannot be undone.': 'Hapus catatan ini? Tindakan ini tidak dapat dibatalkan.',
  'Could not load notes': 'Tidak dapat memuat catatan',
  'Could not add note': 'Tidak dapat menambahkan catatan',
  'Could not update note': 'Tidak dapat memperbarui catatan',
  'Could not save note': 'Tidak dapat menyimpan catatan',
  'Could not remove note': 'Tidak dapat menghapus catatan',

  // --- Activity tab --------------------------------------------------------------------
  'Could not load activity': 'Tidak dapat memuat aktivitas',
  'by {name}': 'oleh {name}',
  'No activity yet': 'Belum ada aktivitas',
  'Changes to this supplier will appear here.': 'Perubahan pada pemasok ini akan muncul di sini.',
  'Load more': 'Muat lebih banyak',

  // --- Catalog / price list tab ---------------------------------------------------------
  'Could not load catalog': 'Tidak dapat memuat katalog',
  'Price list updated': 'Daftar harga diperbarui',
  'Item created and added': 'Barang dibuat dan ditambahkan',
  'Item added to price list': 'Barang ditambahkan ke daftar harga',
  'Could not save': 'Tidak dapat menyimpan',
  'Item removed from price list': 'Barang dihapus dari daftar harga',
  'Could not remove': 'Tidak dapat menghapus',
  'Supplier SKU': 'SKU pemasok',
  'Pack': 'Kemasan',
  'MOQ': 'MOQ',
  'Lead': 'Waktu tunggu',
  'Add item': 'Tambah barang',
  'No items on this price list': 'Belum ada barang di daftar harga ini',
  'Add catalog items this supplier sells, with their prices and pack sizes. You can link existing items or create new ones.': 'Tambahkan barang katalog yang dijual pemasok ini, lengkap dengan harga dan ukuran kemasannya. Anda dapat menautkan barang yang sudah ada atau membuat yang baru.',
  'Edit price list entry': 'Ubah entri daftar harga',
  'Add item to price list': 'Tambah barang ke daftar harga',
  'Add to price list': 'Tambah ke daftar harga',
  'Remove item': 'Hapus barang',
  "Remove \"{name}\" from this supplier's price list? The catalog item itself is not deleted.": 'Hapus "{name}" dari daftar harga pemasok ini? Barang katalognya sendiri tidak dihapus.',
  '— No unit —': '— Tanpa satuan —',
  '— No category —': '— Tanpa kategori —',
  'Choose an item.': 'Pilih barang.',
  'Enter an item name.': 'Masukkan nama barang.',
  'Pack size must be greater than 0.': 'Ukuran kemasan harus lebih dari 0.',
  'Must be ≥ 0.': 'Harus ≥ 0.',
  'Existing item': 'Barang yang sudah ada',
  'Create new item': 'Buat barang baru',
  'Catalog item': 'Barang katalog',
  'Search catalog…': 'Cari katalog…',
  'Search items…': 'Cari barang…',
  'No items available': 'Tidak ada barang tersedia',
  'Item name': 'Nama barang',
  'e.g. Roma tomatoes': 'mis. Tomat Roma',
  'Internal code (optional)': 'Kode internal (opsional)',
  'Stock unit': 'Satuan stok',
  'Vendor reference': 'Referensi vendor',
  'As listed by supplier': 'Sesuai daftar pemasok',
  'Purchase unit': 'Satuan beli',
  'Pack size': 'Ukuran kemasan',
  'Stock units per purchase unit (e.g. 24).': 'Jumlah satuan stok per satuan beli (mis. 24).',
  'Price (per purchase unit)': 'Harga (per satuan beli)',
  'Min. order qty': 'Kts pesan min.',
  'Preferred source for this item': 'Sumber utama untuk barang ini',

  // --- Purchases tab --------------------------------------------------------------------
  'Could not load purchase orders': 'Tidak dapat memuat pesanan pembelian',
  'PO #': 'No. PO',
  'Expected': 'Perkiraan tiba',
  'No purchase orders yet': 'Belum ada pesanan pembelian',
  'Purchase orders issued to this supplier will appear here.': 'Pesanan pembelian yang diterbitkan ke pemasok ini akan muncul di sini.',

  // --- Spend tab --------------------------------------------------------------------
  'Could not load spend': 'Tidak dapat memuat pengeluaran',
  'No spend to report yet': 'Belum ada pengeluaran untuk dilaporkan',
  'Once purchase orders are approved or sent to this supplier, spend analytics will appear here.': 'Setelah pesanan pembelian disetujui atau dikirim ke pemasok ini, analitik pengeluaran akan muncul di sini.',
  'Figures shown in': 'Angka ditampilkan dalam',
  '{count} orders in other currencies are excluded.': '{count} pesanan dalam mata uang lain tidak disertakan.',
  'Total spend': 'Total belanja',
  '{count} committed orders': '{count} pesanan terkonfirmasi',
  'Average order': 'Rata-rata pesanan',
  'Largest order': 'Pesanan terbesar',
  'Open pipeline': 'Pesanan berjalan',
  '{count} draft/pending': '{count} draf/menunggu',
  'First order': 'Pesanan pertama',
  'Last order': 'Pesanan terakhir',
  'Spend over the last 12 months': 'Pengeluaran 12 bulan terakhir',
  '{month}: {amount} ({count} orders)': '{month}: {amount} ({count} pesanan)',
  'Spend by category': 'Pengeluaran per kategori',
  'No categorized spend.': 'Tidak ada pengeluaran terkategori.',
  'Orders by status': 'Pesanan per status',
  '{count} orders': '{count} pesanan',
  'Top items by spend': 'Barang teratas berdasarkan pengeluaran',
  'No committed line items yet.': 'Belum ada baris barang terkonfirmasi.',
  'Qty ordered': 'Kts dipesan',
};

export default suppliers;
